
import { EditIcon } from "./Icon";
import React, { useState, useEffect, memo  } from 'react';


const EditableField = ({ label, field, value, isEditable, onChange, handleEditClick }) => (
  <div style={{ marginBottom: '10px' }}>
    <div className="text-medium" style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
      <label htmlFor={field}>{label}</label>
    </div>
    <div className="text-small" style={{ position: 'relative' }}>
      {field === "note" ? (
        <textarea
          id={field}
          aria-label={label}
          value={value || ""}
          placeholder={value || ""}
          disabled={!isEditable}
          onChange={(e) => onChange(e.target.value)}
          style={{
            width: '100%',
            padding: '20px',
            height: '12rem',
            cursor: isEditable ? 'text' : 'pointer',
            resize: 'none'
          }}
        />
      ) : (
        <input
          id={field}
          type="text"
          aria-label={label}
          value={value || ""}
          placeholder={value || ""}
          disabled={!isEditable}
          onChange={(e) => onChange(e.target.value)}
          style={{ width: '100%', paddingRight: '2rem', cursor: isEditable ? 'text' : 'pointer' }}
        />
      )}

      <EditIcon
        onClick={() => handleEditClick(field)}
        role="button"
        tabIndex="0"
        aria-label={`Edit ${label}`}
        onKeyDown={(e) => e.key === 'Enter' && handleEditClick(field)}
      />
    </div>
  </div>
);

const FieldTextStatic = ({ label, value }) => {
  return (
    <div>
      <label id={`${label}-label`} className="text-medium">
        {label}
      </label>
      <p
        id={`${label}-value`}
        className="text-small"
        aria-labelledby={`${label}-label`}
      >
        {(value || "Non spécifié").toUpperCase()}
      </p>
    </div>
  );
};

const FieldText = ({ label, value, onChange, required}) => (
    <div style={{ marginTop: '10px', textAlign: 'start' }}>
      <label htmlFor={label} className="text-medium">
        {label}
      </label>
      <input
        id={label}
        type='text'
        value={value}
        onChange={onChange}
        className="text-small"
        style={{
          width: '100%',
          padding: '5px',
          marginTop: '5px',
          border: '1px solid #ccc',
          borderRadius: '5px',
        }}
        aria-label={label}
        required={required}
      />
    </div>
  );

  const FieldTextArea = memo(({ label, value, onChange, required }) => {
    const [rows, setRows] = useState(1);

    useEffect(() => {
      // Ajuster le nombre de lignes uniquement si nécessaire
      const charsPerLine = 30; // Nombre approximatif de caractères par ligne
      const lineCount = value ? Math.ceil(value.length / charsPerLine) : 1;
      const newRows = Math.min(Math.max(lineCount, 1), 10); // Limite entre 1 et 10 lignes

      if (newRows !== rows) {
        setRows(newRows);
      }
    }, [value, rows]);

    return (
      <div style={{ marginTop: "10px", textAlign: "start" }}>
        <label htmlFor={label} className="text-medium">
          {label}
        </label>
        <textarea
          id={label}
          type="text"
          value={value}
          onChange={onChange}
          className="text-small"
          style={{
            width: "100%",
            padding: "5px",
            marginTop: "5px",
            border: "1px solid #ccc",
            borderRadius: "5px",
          }}
          aria-label={label}
          required={required}
          rows={rows}
        />
      </div>
    );
  });

  const FieldDate = ({ label, value, onChange, required }) => {
    // Convertit automatiquement un datetime complet en yyyy-MM-dd
    const formatDate = (dateString) => {
      if (!dateString) return "";
      return dateString.slice(0, 10); // extrait "yyyy-MM-dd"
    };

    return (
      <div style={{ marginTop: '10px', textAlign: 'start' }}>
        <label htmlFor={label} className="text-medium">
          {label}
        </label>
        <input
          id={label}
          type="date"
          value={formatDate(value)}
          onChange={onChange}
          className="text-small"
          style={{
            width: '100%',
            padding: '5px',
            marginTop: '5px',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}
          aria-label={label}
          required={required}
        />
      </div>
    );
  };



export default EditableField;
export { FieldText, FieldTextArea,FieldDate, FieldTextStatic };